const BLOCK_SELECTOR = '.wp-block-yoast-faq-block:not(.is-style-classic)';
const SECTION_SELECTOR = ':scope > .schema-faq-section';
const TRANSITION_MS = 250;

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function setPanelClosed(panel) {
  panel.style.height = '0px';
  panel.style.overflow = 'hidden';
  panel.style.transition = '';
}

function setPanelOpen(panel) {
  panel.style.height = 'auto';
  panel.style.overflow = '';
  panel.style.transition = '';
}

function openItem(item, panel) {
  if (prefersReducedMotion()) {
    item.open = true;
    setPanelOpen(panel);
    return;
  }

  item.open = true;
  item.classList.add('is-animating');

  panel.style.overflow = 'hidden';
  panel.style.height = '0px';
  panel.offsetHeight;
  panel.style.transition = `height ${TRANSITION_MS}ms ease-in-out`;
  panel.style.height = `${panel.scrollHeight}px`;

  panel.addEventListener('transitionend', function onTransitionEnd(event) {
    if (event.target !== panel || event.propertyName !== 'height') {
      return;
    }

    panel.removeEventListener('transitionend', onTransitionEnd);
    setPanelOpen(panel);
    item.classList.remove('is-animating');
  });
}

function closeItem(item, panel) {
  if (prefersReducedMotion()) {
    item.open = false;
    setPanelClosed(panel);
    return;
  }

  item.classList.add('is-animating');

  panel.style.overflow = 'hidden';
  panel.style.height = `${panel.scrollHeight}px`;
  panel.offsetHeight;
  panel.style.transition = `height ${TRANSITION_MS}ms ease-in-out`;
  panel.style.height = '0px';

  panel.addEventListener('transitionend', function onTransitionEnd(event) {
    if (event.target !== panel || event.propertyName !== 'height') {
      return;
    }

    panel.removeEventListener('transitionend', onTransitionEnd);
    item.open = false;
    item.classList.remove('is-animating');
    setPanelClosed(panel);
  });
}

function copyAttributes(source, target) {
  Array.from(source.attributes).forEach(({ name, value }) => {
    target.setAttribute(name, value);
  });
}

function createAccordionItem(section) {
  const question = section.querySelector(':scope > .schema-faq-question');
  const answer = section.querySelector(':scope > .schema-faq-answer');

  if (!question || !answer) {
    return null;
  }

  const item = document.createElement('details');
  const summary = document.createElement('summary');
  const marker = document.createElement('span');
  const toggle = document.createElement('span');
  const panel = document.createElement('div');

  copyAttributes(section, item);

  item.classList.add('yoast-faq__item');
  summary.className = 'yoast-faq__summary';
  marker.className = 'yoast-faq__marker';
  marker.setAttribute('aria-hidden', 'true');
  question.classList.add('yoast-faq__question');
  toggle.className = 'yoast-faq__toggle';
  toggle.setAttribute('aria-hidden', 'true');
  panel.className = 'yoast-faq__panel';
  answer.classList.add('yoast-faq__answer');

  summary.append(marker, question, toggle);

  // Keep any future content Yoast adds to a section inside the collapsible panel.
  while (section.firstChild) {
    panel.append(section.firstChild);
  }

  item.append(summary, panel);
  section.replaceWith(item);

  const hashTargetsItem = window.location.hash && window.location.hash.slice(1) === item.id;

  if (hashTargetsItem) {
    item.open = true;
    setPanelOpen(panel);
  } else {
    setPanelClosed(panel);
  }

  summary.addEventListener('click', (event) => {
    if (event.target.closest('a[href]')) {
      return;
    }

    event.preventDefault();

    if (item.classList.contains('is-animating')) {
      return;
    }

    if (item.open) {
      closeItem(item, panel);
      return;
    }

    openItem(item, panel);
  });

  return item;
}

function enhanceBlock(block) {
  if (block.dataset.yoastFaqEnhanced === 'true') {
    return;
  }

  const sections = Array.from(block.querySelectorAll(SECTION_SELECTOR));

  if (!sections.length) {
    return;
  }

  const items = sections.map(createAccordionItem).filter(Boolean);

  if (!items.length) {
    return;
  }

  block.dataset.yoastFaqEnhanced = 'true';
  block.classList.add('yoast-faq--enhanced');
}

function openHashTarget() {
  if (!window.location.hash) {
    return;
  }

  const target = document.getElementById(window.location.hash.slice(1));

  if (!target?.matches('.yoast-faq__item') || target.open) {
    return;
  }

  const panel = target.querySelector(':scope > .yoast-faq__panel');

  if (panel) {
    target.open = true;
    setPanelOpen(panel);
  }
}

function initYoastFaq() {
  document.querySelectorAll(BLOCK_SELECTOR).forEach(enhanceBlock);
  openHashTarget();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initYoastFaq);
} else {
  initYoastFaq();
}

window.addEventListener('hashchange', openHashTarget);
